import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=ce2ce20a&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=ce2ce20a&prod&lang=less&scoped=true"
import style1 from "./Project.vue?vue&type=style&index=1&id=ce2ce20a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ce20a",
  null
  
)

export default component.exports